var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "d-flex justify-content-around h-100 w-100 mobile-nav-item-container",
    },
    [
      _c("router-link", {
        attrs: { to: { name: "Welcome", params: { uuid: _vm.id } } },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ href, route, navigate, isActive, isExactActive }) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "mobile-nav-item",
                    class: [
                      isActive && "active",
                      isExactActive && "exact-active",
                    ],
                    on: { click: navigate },
                  },
                  [
                    _c("div", { staticClass: "mobile-nav-icon" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            height: "24",
                            viewBox: "0 0 24 24",
                            width: "24",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M20 11V9a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h4m4 5v-4a2 2 0 1 1 4 0v4m-4-2h4m3-4v6",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm._f("trans")("Create")))]),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("router-link", {
        attrs: { to: { name: "StyleCanvas", params: { uuid: _vm.id } } },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ href, route, navigate, isActive, isExactActive }) {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "mobile-nav-item d-flex d-inline-flex align-items-center h-100 gap-50",
                    class: [
                      isActive && "active",
                      isExactActive && "exact-active",
                    ],
                    on: { click: navigate },
                  },
                  [
                    _c("div", { staticClass: "mobile-nav-icon" }, [
                      _c("i", { staticClass: "far fa-style lh-inherit fa-2x" }),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm._f("trans")("Styles")))]),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("router-link", {
        attrs: { to: { name: "PromptEditorCanvas", params: { uuid: _vm.id } } },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ href, route, navigate, isActive, isExactActive }) {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "mobile-nav-item d-flex d-inline-flex align-items-center h-100 gap-50",
                    class: [
                      isActive && "active",
                      isExactActive && "exact-active",
                    ],
                    on: { click: navigate },
                  },
                  [
                    _c("div", { staticClass: "mobile-nav-icon" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "25",
                            height: "21",
                            viewBox: "0 0 12 8",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              stroke: "white",
                              d: "M1.33325 0.666626L4.66659 3.99996L1.33325 7.33329M6.66659 7.33329H10.6666",
                              "stroke-width": "1.33333",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm._f("trans")("Prompt")))]),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("router-link", {
        attrs: { to: { name: "JobCanvas", params: { uuid: _vm.id } } },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ href, route, navigate, isActive, isExactActive }) {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "mobile-nav-item d-flex d-inline-flex align-items-center h-100 gap-50",
                    class: [
                      isActive && "active",
                      isExactActive && "exact-active",
                    ],
                    on: { click: navigate },
                  },
                  [
                    _c("div", { staticClass: "mobile-nav-icon" }, [
                      _c("i", { staticClass: "far fa-image lh-inherit fa-2x" }),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm._f("trans")("Creations")))]),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }